<template>
  <div class="tile flex-wrap columns is-mobile" id="tabela-videos">
    <div class="column is-3" v-for="video in videos" :key="video.id">
      <cardvideo :video="video" />
    </div>
  </div>
</template>


<script>
//colocar na pasta tile
import cardvideo from "@/components/Video";

export default {
  name: "Video",
  data() {
    return {};
  },
  components: {
    cardvideo: cardvideo
  },
  props: ["videos", "checkedTags"],
  created() {}
};
</script>